import ShareSheet from '~/shared/modules/share-sheet';
import { AuthFlow } from '~/auth-flow';

const triggerSignupModal = () => {
  AuthFlow.openAuthDialog({ context: 'shot-page-feed' });
};

function setShareEvents() {
  const sharedWrappers = document.querySelectorAll('.js-share-actions');

  if (sharedWrappers) {
    sharedWrappers.forEach((el) => {
      const { body, imageUrl } = el.dataset;

      const options = {
        area: 'Content Hubs',
        container: el,
        body,
        imageUrl,
        outlets: [
          'facebook',
          'twitter',
          'linkedin',
          'email',
          'clipboard',
        ],
        attach: {
          facebook: '.js-facebook-btn',
          twitter: '.js-twitter-btn',
          linkedin: '.js-linkedin-btn',
          email: '.js-email-btn',
          clipboard: '.js-clipboard-btn',
        },
      };

      new ShareSheet(options);
    });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  setShareEvents();

  document.querySelectorAll('[data-signup-cta]').forEach((cta) => {
    cta.addEventListener('click', triggerSignupModal);
  });
});
